/* eslint-disable */
import colors from '../../../../../public/colors'
export default theme => {
    const { mode } = theme.palette
    return {
        nextButton: {
            '&.MuiButton-root': {
                backgroundColor: '#FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: '#003168',
                height: '32px',
                padding: '8px 16px',
                width: 'auto'
            }
        },
        appsButton: {
            maxWidth: '100%',
            '&.MuiButton-root': {
                backgroundColor: colors[mode].insightCardHover,
                border: `1px solid ${colors[mode].cardImageTextAppHover}`,
                boxShadow: 'none',
                color: colors[mode].mfaActiveBackground,
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                textOverflow: 'initial',
                [theme.breakpoints.down('sm')]: {
                    fontSize: '10px'
                },
                height: '32px',
                width: 'auto'
            }
        },
        loader: {
            height: '100%',
            left: '0',
            position: 'absolute',
            top: '0',
            width: '100%',
            'z-index': '10'
        },
        signIntoApps: {
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            alignItems: 'center',
            justifyContent: 'center',
            [theme.breakpoints.down('sm')]: {
                paddingLeft: '5px',
                paddingRight: '5px'
            }
        },
        italics: {
            fontStyle: 'italic'
        },
        firstPart: {
            display: 'grid',
            gridTemplateRows: 'auto auto 25px',
            justifyContent: 'center',
            minHeight: '180px',
        },
        buttonContainer: {
            alignSelf: 'start',
            justifySelf: 'center'
        },
        secondPart: {
            display: 'grid',
            gridTemplateRows: '18% 26% 10% auto',

            justifyContent: 'center',
            minHeight: '250px',
            paddingTop: '5%',
        },
        secondPartText: {
            paddingLeft: '4%',
        },
        checkIcon: {
            color: colors[mode].successText,
            width: '61px',
            height: '61px',

            alignSelf: 'end',
            justifySelf: 'center'
        },
        registrationSuccess: {
            color: colors[mode].successText,
            alignSelf: 'center',
            justifySelf: 'center',
            fontSize: '1.25rem',
        },
        loginTextFirst: {
            maxWidth: '350px',
            textAlign: 'center',
            width: '100%',
            alignSelf: 'center',
            justifySelf: 'center',
            fontSize: '0.875rem',
            color: colors[mode].cardDescription,
            fontWeight: 400,
        },
        loginTextSecond: {
            fontWeight: 400,
            maxWidth: '550px',
            textAlign: 'center',
            width: '100%',
            alignSelf: 'start',
            justifySelf: 'center',
            fontSize: '0.875rem',
            color: colors[mode].cardDescription,
        }
    }
}
